<template>
  <div class="page">
    <div class="nav1">
      来访登记
    </div>
    <div class="form">
      <van-form @submit="onSubmit" aria-autocomplete="false">

        <div class="sub-title">拜访时间</div>
        <div>


          <!-- <van-field required readonly clickable v-model="form.day" name="day" label="来访日期" placeholder="请选择来访日期"
            :rules="[{ required: true, message: '请选择来访日期' }]" @click="showCalendar = true" />
          <van-calendar v-model="showCalendar" @confirm="onConfirm" /> -->

          <van-field required readonly clickable name="startTime" v-model="form.startTime" label="到访时间"
            placeholder="选择到访时间" @click="showStartTimePicker = true" :formatter="formmatTime" />
          <van-popup v-model="showStartTimePicker" position="bottom">
            <van-datetime-picker type="datetime" @confirm="onConfirmTime('startTime', $event)" v-model="form.startTime"
              @cancel="showStartTimePicker = false" />
          </van-popup>


          <!-- <van-field v-model="form.password" name="开始时间" label="开始时间" placeholder="请选择开始时间"
            :rules="[{ required: true, message: '请选择开始时间' }]" /> -->


          <van-field readonly clickable name="endTime" v-model="form.endTime" label="离开时间" placeholder="请选择离开时间"
            :rules="[{ required: true, message: '请选择离开时间' }]" @click="showEndTimePicker = true"
            :formatter="formmatTime" />

          <van-popup v-model="showEndTimePicker" position="bottom">
            <van-datetime-picker type="datetime" @confirm="onConfirmTime('endTime', $event)" :value="form.endTime"
              @cancel="showEndTimePicker = false" />
          </van-popup>


        </div>


        <div class="sub-title">我要拜访</div>
        <div>
          <van-field required v-model="form.visitorName" name="toName" label="姓名" placeholder="请输入被访问人姓名"
            :rules="[{ required: true, message: '' }]" @blur="checkToUer" />
          <van-field required v-model="form.visitorMobile" name="toMobile" label="手机号" type="tel"
            placeholder="请输入被访问人手机号" :rules="[{ required: true, message: '' }]" @blur="checkToUer" />

        </div>
        <div class="sub-title">我的信息</div>
        <div>
          <van-field required v-model="form.username" name="username" label="姓名" placeholder="请输入被姓名"
            :rules="[{ required: true, message: '' }]" />
          <van-field required v-model="form.mobile" name="mobile" label="邮箱" type="email" placeholder="请输入邮箱"
            :rules="[{ required: true, message: '' }]" />

          <!-- <van-field required v-model="form.idcard" name="idcard" label="身份证" type="idcard" placeholder="请输入身份证"
            :rules="[{ required: true, message: '' }]" /> -->

          <van-field required v-model="form.company" name="company" label="公司" placeholder="请输入公司"
            :rules="[{ required: true, message: '' }]" />

          <van-field v-model="form.carno" name="VehicleNo" label="车牌号" placeholder="请输入车牌号"
            :rules="[{ required: false, message: '' }]" />

          <van-field required v-model="form.reason" name="reason" label="来访事由" placeholder="请输入来访事由"
            :rules="[{ required: true, message: '' }]" />

          <van-field required name="attachments.a" label="健康码" :rules="[{ required: true, message: '请上传健康码' }]">
            <template #input>
              <van-uploader :max-count="1" v-model="uploader1"></van-uploader>
            </template>
          </van-field>
          <van-field required name="attachments.b" label="行程卡" :rules="[{ required: true, message: '请上传行程卡' }]">
            <template #input>
              <van-uploader :max-count="1" v-model="uploader2" />
            </template>
          </van-field>
        </div>
        <div class="rule">
          <van-checkbox v-model="sureRule" shape="square" />&nbsp;&nbsp;我已阅读并同意 <a @click="checkbox = true">《隐私保护策略》</a>
        </div>
        <div style="margin: 16px;">
          <van-button :loading="loading" :disabled="!isVaildUser" round block type="info" native-type="submit">提交申请
          </van-button>
        </div>
      </van-form>

      <van-dialog v-model="checkbox" title="" show-cancel-button confirm-button-text="同意"
        @confirm="sureRule = true; checkbox = false;">
        <div class="wrapper" @click.stop>
          <div class="block">
            <p>尊敬的访客：</p>
            <span>
              本次受访，需收集您的个人信息（姓名/邮箱/所属公司），用于汉高安保防控；
              我们会采取严格的数据安全保障措施保护您的信息安全；
              本次收集信息将会在系统内保存6个月，期满后将安全删除您的个人信息；
              点击“同意”，我们将为您提供下一步服务，谢谢！
            </span>
          </div>
        </div>
      </van-dialog>

      <!-- <van-overlay :show="checkbox" @click="checkbox = false">

      </van-overlay> -->

    </div>
  </div>
</template>

<script>
import { NavBar, Calendar, DatetimePicker, Form, Uploader } from 'vant'
import dayjs from 'dayjs'
export default {
  data() {
    return {
      readonly: true,
      showStartTimePicker: false,
      showEndTimePicker: false,
      showCalendar: false,
      checkbox: false,
      loading: false,
      finished: false,
      sureRule: false,
      error: null,
      list: [],
      isVaildUser: false,
      uploader1: [],
      uploader2: [],
      form: {
        // day: dayjs().format("YYYY/MM/DD"),
        startTime: dayjs().toDate(),
        endTime: dayjs().add(4, 'hour').toDate(),
        reason: '',
        visitorName: '',
        visitorMobile: ''
      }
    }
  },
  components: {
    'van-form': Form,
    'van-nav-bar': NavBar,
    'van-calendar': Calendar,
    'van-datetime-picker': DatetimePicker,
    'van-uploader': Uploader
  },
  methods: {
    onLoad() {

    },
    checkToUer() {
      console.log('checkToUer', this.form);
      if (this.form.visitorName && this.form.visitorMobile) {
        this.axios
          .post('apply/check', { toName: this.form.visitorName, toMobile: this.form.visitorMobile })
          .then(res => {
            if (res.errorCode == 0) {
              this.isVaildUser = true;
            }
            else {
              this.isVaildUser = false;

              this.$toast(res.errorMessage)
            }
          })
      }
    },
    formmatTime(date) {
      return dayjs(date).format("YYYY/MM/DD HH:mm")
    },
    // onConfirm(date) {
    //   console.log(date);
    //   this.form.day = dayjs(date).format("YYYY/MM/DD")
    //   this.showCalendar = false;
    // },
    onConfirmTime(type, time) {
      this.form[type] = time;
      this.showStartTimePicker = false;
      this.showEndTimePicker = false;
    },
    goToFaceVaild(id) {
      // this.$dialog.loading();
      this.loading = true
      const that = this;
      let successUrl = encodeURIComponent(`${window.location.origin}/appointment/success?id=${id}`)
      let failedUrl = encodeURIComponent(`${window.location.origin}/appointment/info?id=${id}`)
      this.axios
        .get('baiduai/getVerifyUrl', { params: { applyId: id } })
        .then(res => {
          if (res.errorCode == 0) {
            console.log(res.data)
            let url = `https://brain.baidu.com/face/print/?token=${res.data}&successUrl=${successUrl}&failedUrl=${failedUrl}`;
            window.location.href = url;
          } else {
            this.loading = false
            this.$dialog.alert({
              title: '系统提示',
              message: res.errorMessage,
            }).then(res => {
            })
          }
        })
        .catch(error => {
          console.log(error)
          this.loading = false
          this.$dialog.alert({
            title: '系统提示',
            message: error.message
          }).then(res => {

          })
        })
    },
    onSubmit(e) {
      // console.log(e);
      // console.log(this.sureRule);
      let attachments = [];
      Object.keys(e).forEach(key => {
        if (key.startsWith('attachments.')) {
          attachments = [...attachments, ...e[key].map(t => { return { content: t.content } })]
          delete e[key];
        }
      })

      e.attachments = attachments;
      if (this.sureRule !== true) {
        this.$dialog.alert({
          title: '系统提示',
          message: '请阅读并同意隐私保护策略'
        })
        return;
      }
      this.loading = true
      this.axios
        .post('apply/apply', { ...e })
        .then(res => {
          if (res.errorCode == 0) {
            this.loading = false
            console.log(res.data)
            // 跳转到下一步

            this.$router.replace({
              path: '/appointment/info',
              query: { id: res.data }
            })
            // this.goToFaceVaild(res.data)
          } else {
            this.loading = false
            this.$dialog.alert({
              title: '系统提示',
              message: res.errorMessage
            })
          }
        })
        .catch(error => {
          console.log(error)
          this.loading = false
          this.$dialog.alert({
            title: '系统异常',
            message: error.message
          })
        })
    },
    onClickLeft() { },

    upload() {
      wx.chooseImage({
        count: 1, // 默认9
        sizeType: ['original', 'compressed'], // 可以指定是原图还是压缩图，默认二者都有
        sourceType: ['album'], // 可以指定来源是相册还是相机，默认二者都有
        success: function (res) {
          var localIds = res.localIds; // 返回选定照片的本地ID列表，localId可以作为img标签的src属性显示图片
          console.log(localIds)
        }
      });
      return false
    }
  }
}
</script>

<style scoped lang="less">
.page {
  min-height: 100vh;
  background: #3a88f2;

  .nav1 {
    height: 80px;
    color: #fff;
    line-height: 80px;
    text-indent: 10px;
    font-size: 24px;

    span {
      color: #2765b7;
      font-size: 20px;
    }
  }

  .form {
    background: #f8f8f8;
    border-top-right-radius: 5px;
    border-top-left-radius: 5px;
    padding-top: 10px;
    box-sizing: border-box;
    min-height: calc(100vh - 80px);
    padding-bottom: 10px;
    width: 100%;

    .sub-title {
      margin: 0;
      padding: 16px 16px 16px;
      color: #333333;
      font-weight: normal;
      font-size: 16px;
      line-height: 16px;
      font-weight: bold;
    }

    .rule {
      margin: 16px;
      display: flex;
      align-items: center;
      justify-content: center;

      a {
        color: #63a1f5;
      }
    }
  }

  .block {
    background: #FFF;
    width: 80%;
    margin: 0 auto;
    justify-content: center;
    // padding: 20px 24px;
    margin-top: 30px;
    box-sizing: border-box;

    p {
      margin: 0;
      padding: 0;
      margin-bottom: 12px;
    }

    span {
      line-height: 25px;
      font-size: 13px;
      text-indent: 20px;
    }
  }
}
</style>
